// extracted by mini-css-extract-plugin
export default {"cls1":"Uixwb2l7laRNsC1D33pZ","cls2":"QQ5VzAM7yUT8qNoawDAT Uixwb2l7laRNsC1D33pZ"};